export default __webpack_public_path__ + "static/media/es.3b87288b.svg";